module.exports = __webpack_public_path__ + "static/media/NO_DATAFOUND.c533122c.png";